<template>
    <div>
        <v-row>
            <v-col cols="12" md="8">
                <v-card>
                    <v-progress-linear :indeterminate="loading" height="4"
                                       style="padding:0; margin:0;"></v-progress-linear>

                    <form-generator :resource="resource" :table="table"></form-generator>

                </v-card>
            </v-col>

            <v-col cols="12" md="4" class="fix-element">
                <div>
                    <v-btn @click="saveItem()" color="primary" dark block>
                        Potvrdi
                    </v-btn>

                    <v-btn @click="goBack()" class="mt-4" color="primary" dark block outlined>
                        Odustani
                    </v-btn>
                </div>
            </v-col>
        </v-row>
    </div>
</template>

<script>
  import {serverBus} from "../../main";

  import FormGenerator from "../add/FormGenerator";

  export default {

    components: {
      FormGenerator
    },

    props: [
      'customTable'
    ],

    created: function () {
      this.table = this.customTable ? this.customTable : this.$route.params.table;
      this.resource.id = this.$route.params.resource_id;

      this.getGeneralData();

      setTimeout(function () {
        serverBus.$emit('get-add-view-data');
      }, 30);

      let self = this;
      serverBus.$on('perform-action-after-save', function () {
        if(self.table === 'korisnik'){
          self.$navigate('/admin/pregled/' + self.table);
        } else if(self.activeRole.role_id === 3 && self.table === 'skola') {
          /* ako postoji moja škola, odnosno ako je trenutna rola u sustavu školski kooridantor neka vodi na moja_skola */
          self.$navigate('/admin/moja_skola');
        } else {
          self.$navigate('/admin/' + self.table);
        }
      });
    },

    computed: {
      activeRole() {
        return this.$store.getters.getCurrentRole;
      }
    },

    methods: {
      saveItem() {
        serverBus.$emit('save-add-view-data');
      },

      getGeneralData() {
        this.$axios.post(this.table + '/opcenito').then(response => {
          this.breadcrumbs = response.data['breadcrumbs'];
          this.breadcrumbs.push({text: 'New item'})

          if (this.title === '') {
            this.title = response.data['title'];
          }
        });
      },

      goBack() {
        this.$router.go(-1);
      }
    },

    beforeDestroy() {
      serverBus.$off('perform-action-after-save');
    },

    data: function () {
      return {
        dialog: false,
        loading: false,
        breadcrumbs: [],
        table: '',
        title: '',
        resource: {}
      }
    },
  }
</script>

<style>
    .fix-element {
        position: -webkit-sticky;
        position: sticky;
        top: 5rem;
        align-self: flex-start;
    }
</style>